import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { TimeSeriesService } from "./timeseries.service";
import { WMSClientService } from "./wms-client.service";
import { DataDownloadService } from "./data-download.service";

export * from './terrakio-layer';
export * from "./timeseries.service";
export * from "./wms-client.service";
export * from './data-download.service';

const services = [
  TimeSeriesService,
  WMSClientService,
  DataDownloadService
]

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  exports: [],
  providers: services
})
export class TerrakioModule {
  static forRoot(moduleInitialisation: any): ModuleWithProviders<TerrakioModule> {
    return {
      ngModule: TerrakioModule,
      providers: services
    };
  }
}

